import { useCreate, useDelete, useGetAll, useGetOne, useUpdate } from "./crudService";

const endpoint:string = 'grants';

export function useGetAllGrants(params:{page:number}, queryParams:any = {}) {
    return useGetAll({queryKey: [endpoint], ...queryParams}, params);
}

export function useGetGrant(id: number, params:any = {}) {
    return useGetOne({queryKey: [endpoint, id], ...params});
}

export function useCreateGrant() {
    return useCreate({queryKey: [endpoint]});
}

export function useUpdateGrant({id}) {
    return useUpdate({queryKey: [endpoint, id]});
}

export function useDeleteGrant({id}) {
    return useDelete({queryKey: [endpoint, id]});
}
